import { stats } from "@/src/lib/logging/stats.server";

export async function withEcwMetric<T>(
  operation: string,
  tags: Record<string, string>,
  fn: () => Promise<T>
): Promise<T> {
  const start = performance.now();

  try {
    const result = await fn();

    stats.timer(`ecw.${operation}.duration_ms`, performance.now() - start, { tags: { ...tags, outcome: "success" } });
    stats.counter(`ecw.${operation}.completed`, 1, { tags: { ...tags, outcome: "success" } });

    return result;
  } catch (error) {
    stats.timer(`ecw.${operation}.duration_ms`, performance.now() - start, { tags: { ...tags, outcome: "failure" } });
    stats.counter(`ecw.${operation}.completed`, 1, { tags: { ...tags, outcome: "failure" }, error });

    throw error;
  }
}
